import { atom } from 'jotai';
import { AuthCredentials, Issue, Sprint, UserAllocation, Project } from '@/types';

// Authentication state
export const authCredentialsAtom = atom<AuthCredentials | null>(null);
export const isAuthenticatedAtom = atom<boolean>(false);

// Data state
export const sprintsAtom = atom<Sprint[]>([]);
export const issuesAtom = atom<Issue[]>([]);
export const projectsAtom = atom<Project[]>([]);
export const userAllocationsAtom = atom<UserAllocation[]>([]);

// Loading state
export const isLoadingAtom = atom<boolean>(false);
export const errorAtom = atom<string | null>(null);